import React from "react";
import styles from "./Button.module.css";

export const ButtonOrange = (props) => {
  const { onClick } = props;
  return (
    <button
      className={`${styles.button} ${styles.buttonOrange}`}
      onClick={onClick}
    >
      {props.children}
    </button>
  );
};

export const ButtonWhite = (props) => {
  const { onClick } = props;
  return (
    <button
      className={`${styles.button} ${styles.buttonWhite}`}
      onClick={onClick}
    >
      {props.children}
    </button>
  );
};
